"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["imgUrl"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from 'react';
import { BoxedMessageScreen } from '../BoxedMessageScreen';
import { CDN } from '@autoguru/global-configs';
import { jsx as _jsx } from "react/jsx-runtime";
export const NoResults = /*#__PURE__*/memo(_ref => {
  let {
      imgUrl = `${CDN}/images/illustrations/noresults.svg`
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BoxedMessageScreen, _objectSpread(_objectSpread({}, rest), {}, {
    imgUrl: imgUrl
  }));
});